import React, { useMemo, memo } from 'react';
import { Select } from '@/components';
import { SelectValueType } from '@/components/Select';
import { typeToIcon, CHAIN_IDS } from './chain';
import styles from './home.module.css';

export interface ISelectChainProps {
  chain: SelectValueType;
  setChain: (chain: SelectValueType) => void;
}

const options = [
  { label: 'Ethereum', value: CHAIN_IDS.ETH },
  { label: 'Arbitrum', value: CHAIN_IDS.ARBITRUM }
];

const SelectChain: React.FC<ISelectChainProps> = ({ chain, setChain }) => {
  const selectedChain = useMemo(() => {
    const option = options.find(option => option.value === chain);
    if (option) {
      const IconComponent = typeToIcon[chain];
      return (
        <div className={styles.selected}>
          <IconComponent className={styles.selectedIcon} />
          <span className={styles.selectedText}>{option.label}</span>
        </div>
      );
    } else {
      return null;
    }
  }, [chain]);

  return (
    <Select
      value={chain}
      onSelect={setChain}
      selected={selectedChain}
      className={styles.select}
    >
      {options.map(option => {
        const IconComponent = typeToIcon[option.value];
        return (
          <Select.Option
            value={option.value}
            label={option.label}
            key={option.value}
          >
            <button type="button" className={styles.option}>
              <IconComponent className={styles.optionIcon} />
              <span className={styles.optionText}>{option.label}</span>
            </button>
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default memo(SelectChain);
